// ABOUTME: Shapes ATS job create payloads and enforces plan limits before submission.
// ABOUTME: Adds clone context only when the server confirmed an accessible source.
import {
    createEmailMaterializationContext,
    processEmailFields
} from "customHooks/useCompleoForm/components/FormMainHelper";
import { EmailPersistenceMode } from "customHooks/useCompleoForm/components/emailPersistence";
import { useAlertDialogFNType } from "customHooks/useDialog";
import _ from "lodash";

export const withJobCloneSubmitContext = (
    fnToRun: any,
    cloneFromJobId?: string
) => {
    if (!cloneFromJobId) {
        return fnToRun;
    }
    const submitWithCloneContext = async (values: any) => {
        return await fnToRun({
            ...values,
            cloneFromJobId
        });
    };
    submitWithCloneContext._compleoApiRequest = fnToRun._compleoApiRequest;
    return submitWithCloneContext;
};

type JobSubmitOptions = {
    status?: "open" | "draft";
    limitJobInfo?: {
        t: any;
        getLimit: (action: CompleoShared.Common.limitType) => Promise<any>;
        callDialog: (args: useAlertDialogFNType) => void;
    };
    emailPersistenceMode: EmailPersistenceMode;
    persistPipelineState?: (pipeline: any) => void;
};

export const getHandleJobSubmit = (
    fnToRun: any,
    {
        status,
        limitJobInfo,
        emailPersistenceMode,
        persistPipelineState
    }: JobSubmitOptions
) => {
    const HandleSubmit = async (values: any) => {
        try {
            if (status === "open" && limitJobInfo !== undefined) {
                const { getLimit, callDialog, t } = limitJobInfo;
                const dataLimit = await getLimit("addJob");
                if (!dataLimit.allowAction) {
                    callDialog({
                        title: t("PLANLIMIT_title"),
                        // bodyText: `Seu plano atingiu o limite de vagas abertas. Limite de vagas: ${dataLimit.maxValue} - Vagas abertas: ${dataLimit.currentTotal}`,
                        bodyText: `${t("PLANLIMIT_jobMessage", {
                            maxValue: dataLimit.maxValue,
                            currentTotal: dataLimit.currentTotal
                        })}. ${t("additionalTextAddJobPlanLimitErros")}`,
                        agreeButtonText: t("COMPLEOGENERAL_CLOSE"),
                        // disagreeButtonText: t("ScorecardDelete_no"),
                        agreeFunction: async () => {
                            return false;
                        }
                    });
                    const retorno: Compleo.IObject = {};
                    retorno.status = 999;
                    return retorno;
                }
            }
            const companyId = values.companyId;
            const clonedValues = _.cloneDeep(values);
            if (status) {
                clonedValues.status = status;
            }

            const stages = values?.pipeline?.stages || [];
            const emailMaterializationContext =
                createEmailMaterializationContext();
            for (let index = 0; index < stages.length; index++) {
                for (const fieldStageName of Object.keys(stages[index])) {
                    if (Array.isArray(stages[index][fieldStageName])) {
                        for (
                            let i = 0;
                            i < stages[index][fieldStageName].length;
                            i++
                        ) {
                            try {
                                clonedValues.pipeline.stages[index][
                                    fieldStageName
                                ][i] = await processEmailFields(
                                    {
                                        ...stages[index][fieldStageName][i],
                                        companyId: companyId
                                    },
                                    emailPersistenceMode,
                                    emailMaterializationContext
                                );
                            } finally {
                                persistPipelineState?.(
                                    _.cloneDeep(values.pipeline)
                                );
                            }
                        }
                    }
                }
            }

            return await fnToRun(clonedValues);
            // return;
        } catch (ex) {
            return ex.response;
        }
    };
    return HandleSubmit;
};
